import { Component, Input } from '@angular/core';
import { GridDto } from '@hub/generated/models';
import { GridController } from '@hub/generated/services';
import { GridMessages } from '@hub/generated/_messages';
import { NotificationService } from '@hub/services/NotificationService';

@Component({
  selector: 'app-grid-settings',
  templateUrl: './gridSettings.component.html'
})
export class GridSettingsComponent {
  constructor(private gridController : GridController, private notificationService : NotificationService) {
  }

  @Input() GridData: GridDto;

  save() {
    this.gridController.UpdateGrid(this.GridData).subscribe(data => {
      this.notificationService.success(GridMessages.GridEditSuccess);
    });;
  }
}
